module.exports = __webpack_public_path__ + "assets/img/redBook_introduce.88c4d10f.png";